import React, { Component } from 'react';
import cn from 'classnames';
import isObject from 'lodash/isObject';
import Select, { ISelectOption } from '@dealroadshow/uikit-select';
import { Tab, TabList as TabListWrp, TabPanel, Tabs } from '@dealroadshow/uikit-tabs';
import dataroomLandingBaseStyles from '@/dataroom/ui/components/Landing/base.module.scss';
import styles from './tabList.module.scss';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';

interface IProps {
  tabs: { value: string, label: string }[],
  defaultTab: string,
  className: string,
  selectClassName: string,
  renderTabContent?: (item: any) => React.ReactNode,
}

class TabList extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      currentTab: this.props.defaultTab,
    };
  }

  onTabChange = (
    selected?: ISelectOption
      | readonly ISelectOption[]
      | React.SetStateAction<string | { value: string }>
      | null,
  ) => {
    this.setState({
      // @ts-ignore
      currentTab: isObject(selected) ? selected.value : selected,
    });
  };

  getTabValue = () => (
    this.props.tabs.find((tab) => tab.value === this.state.currentTab) || null
  );

  render() {
    return (
      <div className={ cardStyles.cardContainer }>
        <div className={ dataroomLandingBaseStyles.mdContainer }>
          <div className={ this.props.selectClassName }>
            <Select
              name="tabs"
              isSearchable={ false }
              options={ this.props.tabs }
              value={ this.getTabValue() as ISelectOption }
              onChange={ this.onTabChange }
              dataTest="tabListSelect"
            />
          </div>
        </div>
        <Tabs
          defaultTab={ this.state.currentTab }
          dataTest="landingSectionsTabListTabs"
          onChange={ this.onTabChange }
        >
          <TabListWrp className={ cn(styles.tabs, this.props.className) }>
            { this.props.tabs.map((tab) => (
              <Tab
                key={ tab.value }
                tabFor={ tab.value }
                className={ styles.tab }
                activeClassName={ styles.isTabActive }
              >
                <span>{ tab.label }</span>
              </Tab>
            )) }
          </TabListWrp>
          { this.props.tabs.map((item) => (
            <TabPanel tabId={ item.value } key={ item.value }>
              { this.props.renderTabContent?.(item) }
            </TabPanel>
          )) }
        </Tabs>
      </div>
    );
  }
}

export default TabList;
